import React from 'react';
import { motion } from 'framer-motion';
import { SectionHeading } from './SectionHeading';
const painPoints = [{
  icon: '🤔',
  title: 'No encontrás un veterinario de confianza',
  desc: 'Te cuesta dar con un profesional que realmente escuche y entienda a tu mascota.',
  color: 'bg-white',
  rotate: '-rotate-2'
}, {
  icon: '😰',
  title: 'Las urgencias te agarran sin saber a quién llamar',
  desc: 'Ese momento de pánico a las 3 AM cuando tu perro se siente mal y no tenés un número seguro.',
  color: 'bg-secondary',
  rotate: 'rotate-2'
}, {
  icon: '📅',
  title: 'Tu mascota necesita vacunas y no sabés cuáles',
  desc: 'El calendario de vacunación parece un laberinto y tenés miedo de olvidarte alguna dosis.',
  color: 'bg-accent',
  rotate: '-rotate-1'
}, {
  icon: '🤷',
  title: 'Querés el mejor cuidado pero no sabés por dónde empezar',
  desc: 'Nutrición, comportamiento, chequeos... hay demasiada información y poca claridad.',
  color: 'bg-primary',
  rotate: 'rotate-1'
}];
export const PainPoints: React.FC = () => {
  return <section className="py-20 bg-bg overflow-hidden" data-id="element-123">
      <div className="container mx-auto px-4" data-id="element-124">
        <SectionHeading title="¿Te preocupa la salud de tu mascota?" subtitle="Sabemos lo frustrante que puede ser buscar atención veterinaria y no sentirte acompañado." data-id="element-125" />

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6 mt-12" data-id="element-126">
          {painPoints.map((point, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 30
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true,
          margin: '-50px'
        }} transition={{
          duration: 0.5,
          delay: index * 0.1
        }} whileHover={{
          scale: 1.05,
          rotate: 0,
          zIndex: 10
        }} className={`${point.color} border-3 border-text rounded-2xl p-6 neo-shadow transform ${point.rotate} transition-all duration-300`} data-id="element-127">
              <div className="text-5xl mb-4 bg-white border-2 border-text rounded-full w-16 h-16 flex items-center justify-center neo-shadow-sm" data-id="element-128">
                {point.icon}
              </div>
              <h3 className="text-xl font-black mb-3 leading-tight" data-id="element-129">
                {point.title}
              </h3>
              <p className="font-medium text-gray-800" data-id="element-130">{point.desc}</p>
            </motion.div>)}
        </div>
      </div>
    </section>;
};